module.exports = __webpack_public_path__ + "img/KMS-M-3.7a292fc9.svg";